export const meta = {
  title: "JavaScript Reference"
};

Google it for now, we're working on this.